import type { ChartConfig } from "@bi-studio/shared/lib";
import type { ChartData, ChartSize } from "./types";
import { clearContainer, resolveColors } from "./utils";

export const renderScoreCard = (
    container: HTMLElement | null,
    data: ChartData,
    config: ChartConfig,
    _size?: ChartSize,
    theme: 'light' | 'dark' = 'light'
): HTMLElement | null => {
    if (!container || typeof window === "undefined") return null;

    clearContainer(container);

    const colors = resolveColors(config, theme);

    // Set container style
    container.style.width = "100%";
    container.style.height = "100%";
    container.style.display = "flex";
    container.style.flexDirection = "column";
    container.style.justifyContent = "center";
    container.style.alignItems = "center";
    container.style.padding = "1rem";
    container.style.textAlign = "center";

    const title = config.title || "Score Card";
    const valueField = config.valueField || "";
    const rowIndex = config.rowIndex !== undefined ? Number(config.rowIndex) : 0;

    const row = data[rowIndex] || data[0] || {};
    const value = row[valueField] !== undefined ? row[valueField] : "-";

    const titleElement = document.createElement("div");
    titleElement.style.fontSize = "1.1rem";
    titleElement.style.fontWeight = "500";
    titleElement.style.color = "var(--mantine-color-dimmed)";
    titleElement.style.marginBottom = "0.75rem";
    titleElement.innerText = title;

    const valueElement = document.createElement("div");
    valueElement.style.fontSize = "3rem";
    valueElement.style.fontWeight = "800";
    valueElement.style.color = colors.length > 0 ? colors[0] : "var(--mantine-color-text)";

    // Format number if it's a number
    if (typeof value === 'number') {
        valueElement.innerText = value.toLocaleString();
    } else {
        valueElement.innerText = String(value);
    }

    container.appendChild(titleElement);
    container.appendChild(valueElement);

    return container;
};
